import { h } from "./../../utils/createElement";
import { __assign, __extends } from "tslib";
import * as React from 'react';
import ReactDOM from 'react-dom';
import { castInto, emptyFn } from '../../utils/helper';
import Trigger from '../../utils/Trigger';
import { consumeTheme } from '../../utils/theme';
import { decideKeepDom } from '../../utils/keepDom';
import PositionChangeDetector from '../../utils/PositionChangeDetector';
var ARROW_GAP = 6;
var POPOVER_TRANSITION_DURATION = 200;
var Popover = (function (_super) {
    __extends(Popover, _super);
    function Popover() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.arrowRef = React.createRef();
        _this.contentRef = React.createRef();
        _this.anchorRef = React.createRef();
        _this.state = {
            visible: false,
            arrowPosition: {},
            contentPosition: {},
            resolvedPlacement: 'bottom',
            forceRenderDom: false,
        };
        _this.hide = function () {
            if (_this.props.disabled) {
                return;
            }
            _this.setState({ visible: false }, _this.determineVisibleChange(false));
        };
        _this.show = function () {
            if (_this.props.disabled) {
                return;
            }
            _this.setState({ forceRenderDom: true }, function () {
                _this.updatePosition();
                _this.setState({ visible: true, forceRenderDom: false }, _this.determineVisibleChange(true));
            });
        };
        _this.toggle = function () {
            if (_this.props.disabled) {
                return;
            }
            if (_this.isVisible()) {
                _this.hide();
            }
            else {
                _this.show();
            }
        };
        _this.stopPropagation = function (e) {
            e.stopPropagation();
        };
        _this.themedRender = function (classNames) {
            var _a, _b, _c, _d;
            var _e = _this.props, prefixCls = _e.prefixCls, className = _e.className, style = _e.style, children = _e.children, popContent = _e.popContent, disabled = _e.disabled, popContentStyle = _e.popContentStyle, arrowStyle = _e.arrowStyle, zIndex = _e.zIndex, destroyOnClose = _e.destroyOnClose, trigger = _e.trigger;
            var _f = _this.state, arrowPosition = _f.arrowPosition, contentPosition = _f.contentPosition, resolvedPlacement = _f.resolvedPlacement, forceRenderDom = _f.forceRenderDom;
            var visible = _this.isVisible();
            var classes = classNames(prefixCls, className, (_a = {},
                _a[prefixCls + "-disabled"] = disabled,
                _a));
            var contentClasses = classNames(prefixCls + "-content");
            var containerClasses = classNames(prefixCls + "-container", (_b = {},
                _b[prefixCls + "-container-hidden"] = !visible,
                _b));
            var arrowClasses = classNames(prefixCls + "-arrow", prefixCls + "-arrow-" + resolvedPlacement);
            var shouldDestroyDom = !forceRenderDom && destroyOnClose && !decideKeepDom.call(_this, POPOVER_TRANSITION_DURATION, visible);
            var useClick = trigger === 'click';
            return (h(Trigger, { className: classes, style: style, action: _this.hide },
                h(PositionChangeDetector, __assign({ domRef: _this.anchorRef, action: _this.hide, disabled: !visible }, (_c = {}, _c[useClick ? 'onClick' : 'onTouchEnd'] = _this.toggle, _c)), children),
                shouldDestroyDom ? null : ReactDOM.createPortal(h("div", { className: containerClasses },
                    h("div", __assign({ className: contentClasses, style: __assign(__assign({ zIndex: zIndex }, popContentStyle), contentPosition), onTouchMove: _this.stopPropagation, ref: _this.contentRef }, (_d = {}, _d[useClick ? 'onClick' : 'onTouchEnd'] = _this.hide, _d)), popContent),
                    h("div", { className: arrowClasses, ref: _this.arrowRef, style: __assign(__assign({ zIndex: zIndex }, arrowStyle), arrowPosition) })), document.body)));
        };
        return _this;
    }
    Popover.getDerivedStateFromProps = function (props, state) {
        if (props.disabled) {
            return { visible: false };
        }
        return null;
    };
    Popover.prototype.componentDidMount = function () {
        if (this.isVisible()) {
            this.updatePosition();
        }
        window.addEventListener('resize', this.hide);
    };
    Popover.prototype.componentWillUnmount = function () {
        window.removeEventListener('resize', this.hide);
    };
    Popover.prototype.componentDidUpdate = function (prevProps) {
        if (!prevProps.visible && this.props.visible) {
            this.updatePosition();
        }
    };
    Popover.prototype.isVisible = function () {
        var forceVisible = this.props.visible;
        var stateVisible = this.state.visible;
        return typeof forceVisible === 'boolean' ? forceVisible : stateVisible;
    };
    Popover.prototype.determineVisibleChange = function (visible) {
        var _this = this;
        if (visible !== this.isVisible()) {
            return function () { return _this.props.onVisibleChange(visible); };
        }
    };
    Popover.prototype.updatePosition = function () {
        var newPosition = this.calcPosition();
        newPosition && this.setState(__assign({}, newPosition));
    };
    Popover.prototype.calcPositionLeft = function (anchorDomRect, contentDomRect, viewportDomRect) {
        var _a = this.props, alignBase = _a.alignBase, propAlignment = _a.alignment, offset = _a.offset, viewportMargin = _a.viewportMargin;
        var viewportLeft = viewportMargin;
        var viewportRight = window.innerWidth - viewportMargin;
        var alignment = propAlignment;
        if (viewportDomRect) {
            var left_1 = viewportDomRect.left, right_1 = viewportDomRect.right;
            viewportLeft = left_1 + viewportMargin;
            viewportRight = right_1 - viewportMargin;
        }
        var left = anchorDomRect.left, right = anchorDomRect.right;
        var contentWidth = contentDomRect.width;
        var leftContentStart = left + offset;
        var centerContentStart = (left + right - contentWidth) / 2 + offset;
        var rightContentStart = right - contentWidth + offset;
        if (alignment === 'auto') {
            if (alignBase === 'viewport') {
                alignment = 'left';
            }
            else if (leftContentStart + contentWidth < viewportRight) {
                alignment = 'left';
            }
            else if (centerContentStart + contentWidth < viewportRight && centerContentStart > viewportLeft) {
                alignment = 'center';
            }
            else {
                alignment = 'right';
            }
        }
        var contentLeft = 0;
        if (alignBase === 'default') {
            if (alignment === 'center') {
                contentLeft = centerContentStart;
            }
            else if (alignment === 'left') {
                contentLeft = leftContentStart;
            }
            else if (alignment === 'right') {
                contentLeft = rightContentStart;
            }
        }
        else if (alignBase === 'viewport') {
            if (alignment === 'center') {
                contentLeft = (viewportLeft + viewportRight - contentWidth) / 2 + offset;
            }
            else if (alignment === 'left') {
                contentLeft = viewportLeft + offset;
            }
            else if (alignment === 'right') {
                contentLeft = viewportRight - contentWidth + offset;
            }
        }
        contentLeft = castInto(contentLeft, [viewportLeft, Math.max(viewportRight - contentWidth, viewportLeft)]);
        return contentLeft;
    };
    Popover.prototype.calcPosition = function () {
        var _a = this.props, placement = _a.placement, arrowOffset = _a.arrowOffset, viewportDom = _a.viewportDom, viewportMargin = _a.viewportMargin, popPosition = _a.popPosition;
        var anchorDom = this.anchorRef.current;
        if (!anchorDom) {
            return null;
        }
        var viewportBottom = window.innerHeight - viewportMargin;
        var viewportTop = viewportMargin;
        var viewportDomRect = null;
        if (viewportDom) {
            viewportDomRect = viewportDom.getBoundingClientRect();
            var bottom_1 = viewportDomRect.bottom, top_1 = viewportDomRect.top;
            viewportBottom = bottom_1 - viewportMargin;
            viewportTop = top_1 + viewportMargin;
        }
        var arrowDom = this.arrowRef.current;
        var contentDomRect = this.contentRef.current.getBoundingClientRect();
        var anchorRect = popPosition
            ? __assign(__assign({}, popPosition), { right: popPosition.left, bottom: popPosition.top }) : anchorDom.getBoundingClientRect();
        var left = anchorRect.left, right = anchorRect.right, top = anchorRect.top, bottom = anchorRect.bottom;
        var contentHeight = contentDomRect.height;
        var arrowDiagonal = arrowDom.getBoundingClientRect().height;
        var arrowLength = arrowDiagonal / Math.SQRT2;
        var arrowLeft = arrowOffset + (left + right - arrowLength) / 2;
        var arrowTop = 0;
        var contentTop = 0;
        var resolvedPlacement = placement;
        if (resolvedPlacement === 'auto') {
            var maxBottom = viewportBottom;
            var minTop = viewportTop;
            var contentOccupiedHeight = ARROW_GAP + arrowLength / 2 + contentHeight;
            var reachedBottom = bottom + contentOccupiedHeight;
            var reachedTop = top - contentOccupiedHeight;
            resolvedPlacement = reachedBottom < maxBottom ? 'bottom' : reachedTop > minTop ? 'top' : 'center';
        }
        if (resolvedPlacement === 'bottom') {
            arrowTop = bottom + ARROW_GAP;
            contentTop = arrowTop + arrowLength / 2;
        }
        else if (resolvedPlacement === 'top') {
            arrowTop = top - ARROW_GAP - arrowLength;
            contentTop = arrowTop + arrowLength / 2 - contentHeight;
        }
        else if (resolvedPlacement === 'center') {
            arrowTop = (bottom + top) / 2 + ARROW_GAP;
            contentTop = arrowTop + arrowLength / 2;
        }
        var contentLeft = this.calcPositionLeft(anchorRect, contentDomRect, viewportDomRect);
        return {
            arrowPosition: { left: arrowLeft + "px", top: arrowTop + "px" },
            contentPosition: { left: contentLeft + "px", top: contentTop + "px" },
            resolvedPlacement: resolvedPlacement
        };
    };
    Popover.prototype.render = function () {
        return consumeTheme(this.themedRender);
    };
    return Popover;
}(React.Component));
export default Popover;
Popover.defaultProps = {
    prefixCls: 'dui-m-popover',
    alignment: 'center',
    disabled: false,
    offset: 0,
    onVisibleChange: emptyFn,
    placement: 'bottom',
    alignBase: 'default',
    arrowOffset: 0,
    destroyOnClose: true,
    viewportMargin: 12,
    trigger: 'click',
};
